import {BehaviorSubject} from 'rxjs';
import {MediaItemInteractor} from '../../ui/media/MediaItemList/MediaItemListPresenter';
import {MediaItem} from '../../models/MediaItem';

export class DefaultMediaItemInteractor implements MediaItemInteractor {
    public mediaItems = new BehaviorSubject<MediaItem[]>(this.initialMediaItems);

    constructor(private initialMediaItems: MediaItem[]) {}

    public add(mediaItem: MediaItem) {
        this.mediaItems.next([...this.mediaItems.value, mediaItem]);
    }

    public delete(toBeDeletedMediaItem: MediaItem): void {
        this.mediaItems.next([
            ...this.mediaItems.value.filter((mediaItem) => mediaItem.__uuid !== toBeDeletedMediaItem.__uuid),
        ]);
    }
}
